const REACT_APP_OKTA_CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;
const REACT_APP_OKTA_ORG_URL = process.env.REACT_APP_OKTA_ORG_URL;
const REACT_APP_OKTA_REDIRECT_URI = process.env.REACT_APP_OKTA_REDIRECT_URI;

// Remove any trailing slashes and https:// from the org URL if present
const cleanOrgUrl = REACT_APP_OKTA_ORG_URL?.replace(/^https?:\/\//, '').replace(/\/$/, '');

export const oktaConfig = {
  clientId: `${REACT_APP_OKTA_CLIENT_ID}`,
  issuer: `https://${cleanOrgUrl}/`,
  redirectUri: `${REACT_APP_OKTA_REDIRECT_URI}`,
  scopes: ["openid", "profile", "email", "groups"],
  pkce: true,
  disableHttpsCheck: process.env.NODE_ENV === 'development',
  tokenManager: {
    autoRenew: true,
    secure: true
  }
};

// Validate config
if (!REACT_APP_OKTA_CLIENT_ID || !REACT_APP_OKTA_ORG_URL) {
  console.error('Missing required Okta configuration. Please check your environment variables:',
    {
      REACT_APP_OKTA_CLIENT_ID: !!REACT_APP_OKTA_CLIENT_ID,
      REACT_APP_OKTA_ORG_URL: !!REACT_APP_OKTA_ORG_URL
    }
  );
}
